<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui icon iconfont" @click="$router.push({name:'case'})"></i>
      <p class="text">案例详情</p>

    </div>

    <div class="listbox">
      <ul>
        <li>
          <p>案例名称</p>
          <p class="txtbox">
            <span>{{caseData.name}}</span>
            </br>
            <span>发布时间：{{caseData.distribute_at}}</span>
          </p>
          <img :src="getIcon(caseData.c_icon)" alt="" class="logoimg">
        </li>




        <li>
          <p>案例描述</p>
          <p class="txtscroll">
            {{caseData.desc}}
          </p>

        </li>



        <li>
          <p>版本信息</p>
          <p class="txtbox">
            <span>{{caseData.v_name}}</span>
            </br>
            <span>{{caseData.v_subname}}</span>
            </br>
            <span>{{caseData.v_no}}</span>
            </br>
            <span>发布时间：{{caseData.v_created_at}}</span>
          </p>
          <img :src="getIcon(caseData.v_icon)" alt="" class="logoimg">
        </li>

        <li>
          <p>时间</p>
          <p class="txtbox">
            <span>创建时间：{{caseData.created_at}}</span>
            </br>
            <span>最后修改时间：{{caseData.last_updated_at}}</span>
            </br>
            <span>发布时间：{{caseData.distribute_at}}</span>
            </br>
            <span>过期时间：{{caseData.expire_at}}</span>
          </p>

          <!--轮播不自动播放-->

          <mt-swipe :auto="0" :show-indicators="false">
            <mt-swipe-item v-for="item in imgSrc" :key="item.id">
              <img :src="getIcon(item)" alt="" class="lbimg">
            </mt-swipe-item>
          </mt-swipe>



          <p>安装／访问信息</p>
          <p class="txtbox">
            <span>安装包大小：{{caseData.install_size}}</span>
            </br>
            <span>文件包大小：{{caseData.package_size}}</span>
            </br>
            <span>安装／访问二维码</span>
          </p>

          <!--二维码图-->
          <qriously :value="caseData.link || ''" :size="140" class="ewmimg"/>
          <!-- <img src="../assets/img/avatar.jpg" alt="" class="ewmimg"> -->
          <a v-clipboard="caseData.link" @success="handleSuccess" @error="handleError" >复制链接</a>

        </li>



        <!-- <li>
          <p>版本说明</p>
          <p class="txtscroll">
            {{caseData.desc}}
          </p>

        </li> -->


      </ul>
    </div>


  </div>
</template>

<script>
import config from '../fetch/config'
import VueClipboards from 'vue-clipboards'
import Vue from 'vue'
import { Swipe, SwipeItem } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.use(VueClipboards)
export default {
  data () {
    return {
      caseData:[],
      imgSrc:[],
    }
  },
  methods:{
    getIcon (icon) {
      return `${config.baseURL.substring(0,config.baseURL.length-1)}${icon}`
    },
    handleSuccess () {
      this.$notice.tip('复制成功')
    },
    handleError () {
      this.$notice.tip('复制失败')
    },
  },
  created () {
    this.caseData = this.$route.params.data
    this.imgSrc = this.$route.params.data.pre_view.split(';')
  },

}
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #fafafa;
  }
  .header{
    width: 100%;
    font-size: 0.375rem;
    height: 1.1875rem;
    line-height: 1.1875rem;
    position: relative;
    margin-bottom: 0.3125rem;
    background: #fff;
    border-bottom: 1px solid #ddd;
  }

  .text{
    font-size: 0.4375rem;
    color: #333;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .listbox{
    width: 100%;
    background: #fff;
    margin-bottom: 5%;
  }
  .listbox ul{
    width: 90%;
    margin: auto;
  }
  .listbox ul li{
    width: 100%;
    position: relative;
    border-bottom: 1px solid #ddd;
    color: #333;
  }
  .listbox ul li p:first-child{
    color: #000;
    padding-left: 1%;
    font-size: 0.4375rem;
    padding-top: 0.375rem;
    margin-bottom: 0.15625rem;
  }
  .txtbox{
    padding-left: 1%;
    font-size: 0.40625rem;
    color: #666;
    margin-bottom: 0.15625rem;
  }
  .logoimg{
    position: absolute;
    right: 1%;
    bottom: 0.21875rem;
    width: 2.3125rem;
    height: 1.65625rem;
  }

  .icon{
    color: #86898E;
    position: absolute;
    /*top: 10%;*/
    left: 2%;
    font-size: 0.5rem;
    font-weight: bold;
    z-index: 2;
    /*transform: rotate(90deg);*/
  }
  .txtscroll{
    overflow: scroll;
    height: 2.25rem;
    margin-bottom: 0.25rem;
    padding-left: 1%;
    font-size: 0.40625rem;
    color: #666;
  }
  .lbimg{
    width: 100%;
    /*border: 1px solid #B5B4B4;*/
    height: 3.28125rem;
  }
  .ewmimg{
    width: 140px;
    height: 140px;
    margin: auto;
    display: block;
  }
  a{
    width: 100%;
    text-align: center;
    display: block;
    text-decoration: none;
    font-size: 0.4375rem;
    color: #5482D1;
    margin-bottom: 0.6875rem;
  }
  .mint-swipe{
    height: 3.28125rem;
  }



</style>



// WEBPACK FOOTER //
// src/components/CaseApp.vue